import i18n from '@i18n';
import Dialog, { DialogBody, DialogTitle } from '@/ui/dialogs/Dialog';
import PopupNg from '@/ui/PopupNg';
import React from 'react';
import { Button } from 'nike-ui/src/components/button/Button';
import { MARKETING_AGREEMENT_ACCEPTED, MARKETING_AGREEMENT_NOT_ACCEPTED } from '@/myprofile/constants';

function ProfileMarketingAgreementModal({ onClick }) {
    const moreInfo = i18n('mkt.modal.gdpr.link');

    function onClickButton(value) {
        onClick(value);
        PopupNg.dispatcher.close('marketingAgreementModal');
    }

    return (
        <Dialog className="" modal>
            <DialogTitle>
                <h2 className="uppercase text-center">{i18n('mkt.modal.title')}</h2>
            </DialogTitle>
            <DialogBody>
                <p className="mt-20 text-center fs-14">{i18n('mkt.modal.text')}</p>
                <p className="mt-30 text-bold text-center fs-14">{i18n('mkt.modal.text.bold')}</p>
                <span
                    className="mt-10 flex justify-center fs-14 blue-link"
                    dangerouslySetInnerHTML={{ __html: moreInfo }}
                />
            </DialogBody>
            <div className="flex items-center flex-col">
                <Button
                    primary
                    className={'my-20 nui-button-180'}
                    label={i18n('mkt.modal.option.yes')}
                    onClick={() => onClickButton(MARKETING_AGREEMENT_NOT_ACCEPTED)}
                />
                <Button
                    secondary
                    onClick={() => onClickButton(MARKETING_AGREEMENT_ACCEPTED)}
                    className="mb-30 mt-20 nui-button-180"
                    label={i18n('mkt.modal.option.no')}
                />
            </div>
        </Dialog>
    );
}

export default ProfileMarketingAgreementModal;
